import type { PeriodeLektioner } from "./efteruddannelse";

export enum PaabudStatus {
  Aabent = 1,
  Lukket = 2,
  Slettet = 3,
}

export enum ChangeStatus {
  Kladde = 0,
  Indsendt = 1,
  Synkroniseret = 2,
  SynkroniseretManuelt = 3,
  Slettet = 4,
}

export type PaabudModel = {
  id: string;
  aikaPaabudId: string;
  personId: string;
  paakraevedeLektioner: number;
  periodeFra: string;
  /**
   * Dagen EFTER periodens sidste dag (til-men-ikke-med), eller null hvis påbuddet er i
   * bero: perioden løber kun, mens advokaten er udøvende.
   */
  periodeTil: string | null;
  /** Periodens sidste dag — den, der skal vises. Null når perioden ikke er udløbet. */
  periodeTilMinusEnDag: string | null;
  bemaerkning: string | null;
  status: PaabudStatus;
  decisionDocumentFileName: string;
  decisionDocumentContentType: string | null;
};

export type PaabudIndberetningOverviewModel = {
  indberetningId: string | null;
  paabudId: string;
  aikaPaabudId: string;
  frist: string | null;
  periodeFra: string;
  periodeTil: string | null;
  periodeTilMinusEnDag: string | null;
  paakraevedeLektioner: number;
  status: PaabudStatus;
  indberetningStatus: ChangeStatus | null;
  indsendt: string | null;
  harAabenIndberetning: boolean;
  lektionerIndberettet: PeriodeLektioner | null;
  lektionerOverfoeresTilNaeste: PeriodeLektioner | null;
};

export type PaabudDetailModel = PaabudModel & {
  indberetningId: string | null;
  frist: string | null;
  indberetningStatus: ChangeStatus | null;
  lektionerIndberettet: PeriodeLektioner | null;
  lektionerOverfoeresTilNaeste: PeriodeLektioner | null;
  indsendt: string | null;
  harAabenIndberetning: boolean;
};
